import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import Select, { SelectChangeEvent } from "@mui/material/Select"
import OutlinedInput from "@mui/material/OutlinedInput"
import MenuItem from "@mui/material/MenuItem"
import Checkbox from "@mui/material/Checkbox"
import ListItemText from "@mui/material/ListItemText"
import * as React from "react"
import { makeStyles } from "tss-react/mui"
import {
    fetchMerchantSatellites,
    FetchMerchantSatellitesResponse,
    MerchantQuery,
} from "../../../../../merchant/admin/merchantAdminApi"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { MenuProps } from "../../../../../../shared/components/filters/constants/filterMenuConst"

type MerchantSatelliteFilterProps = Readonly<{
    value: string[]
    setValue: (value: string[]) => void
    merchantId?: string
}>

const useStyles = makeStyles()(() => ({
    input: {
        width: "20rem",
    },
}))
function transformData(data: FetchMerchantSatellitesResponse) {
    return data.satellites
}

export function MerchantSatelliteFilter({ merchantId, value, setValue }: MerchantSatelliteFilterProps) {
    const { classes } = useStyles()

    const { data } = useApiQuery(fetchMerchantSatellites, {
        queryName: MerchantQuery.SATELLITES_LIST,
        dependencies: {
            merchantId: merchantId ? +merchantId : 0,
        },
        enabled: Boolean(merchantId),
        select: transformData,
    })

    const satelliteMap = React.useMemo(() => {
        const map: { [id: string]: string } = {}
        data?.forEach((satellite) => {
            map[satellite.id] = satellite.name
        })
        return map
    }, [data])

    const selectedNames = value.map((id) => satelliteMap[id] || "")

    const handleChange = (event: SelectChangeEvent<typeof value>) => {
        const {
            target: { value },
        } = event
        const selectedIds = typeof value === "string" ? value.split(",") : value
        const selectedIdValues = selectedIds
            .map((name) => Object.keys(satelliteMap).find((key) => satelliteMap[key] === name))
            .filter((id): id is string => id !== undefined)

        setValue(selectedIdValues)
    }

    return (
        <FormControl className={classes.input}>
            <LocalizedStrict id="supplier-meeting-service-drawer-satellites-label">
                <InputLabel id="multiple-checkbox-satellites-label">Satellites</InputLabel>
            </LocalizedStrict>
            <Select
                labelId="multiple-checkbox-satellites-label"
                id="multiple-checkbox-satellites"
                multiple
                disabled={!Boolean(merchantId)}
                value={selectedNames}
                onChange={handleChange}
                input={<OutlinedInput label="Satellites" />}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
            >
                {data?.map((shop) => (
                    <MenuItem key={shop.id} value={shop.name}>
                        <Checkbox checked={selectedNames.indexOf(shop.name) > -1} />
                        <ListItemText primary={shop.name} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

